export default __webpack_public_path__ + "ac8da1d7592e20da253a567ad4e48acc.svg";